



































import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import UtilsService from "@/mixins/UtilsService";

@Component({})
export default class Dialog extends Mixins(UtilsService) {
  @Getter("message", { namespace: "dialog" }) message!: string;
  @Getter("title", { namespace: "dialog" }) title!: string;
  @Getter("cancel", { namespace: "dialog" }) cancel!: boolean;
  @Getter("callbackFn", { namespace: "dialog" }) callbackFn!: any;
  @Getter("cancelCallbackFn", { namespace: "dialog" }) cancelCallbackFn!: any;
  @Action("closeDialog", { namespace: "dialog" }) closeDialog!: any;

  $refs!: {
    dialogContainer: HTMLElement;
  };

  height!: string;

  constructor() {
    super();
    this.height = "";
  }

  private beforeCreate(): void {}
  private created(): void {}
  private beforeMount(): void {}
  private mounted(): void {
    this.disabledScroll();
    this.setHeight();
  }
  private beforeUpdate(): void {}
  private updated(): void {}
  private beforeDestory(): void {}
  private destroyed(): void {
    this.activationScroll();
  }

  confirm(): void {
    if (this.callbackFn) {
      this.callbackFn();
    }
    this.close();
  }

  close(): void {
    if (this.cancelCallbackFn) {
      this.cancelCallbackFn();
    }
    this.closeDialog();
  }

  private setHeight(): void {
    const clientHeight = this.$refs.dialogContainer.clientHeight;
    this.height = -clientHeight / 2 + "px";
  }
}
